export default "__VITE_ASSET__2fxUjeVL__"